import { Component, Input, Output, HostListener, forwardRef, NgZone, EventEmitter, ViewChild, NgModule } from '@angular/core';
import { NG_VALUE_ACCESSOR, FormsModule } from '@angular/forms';

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/** @type {?} */
import * as ɵngcc0 from '@angular/core';
import * as ɵngcc1 from '@angular/forms';

var _c0 = ["container"];
var _c1 = ["on"];
var _c2 = ["label"];
var _c3 = ["off"];
var callback = function () {
};
/** @type {?} */
var CUSTOM_INPUT = {
    provide: NG_VALUE_ACCESSOR,
    useExisting: forwardRef(function () { return JwBootstrapSwitchNg2Component; }),
    multi: true
};
var JwBootstrapSwitchNg2Component = /** @class */ (function () {
    function JwBootstrapSwitchNg2Component(ngZone) {
        this.ngZone = ngZone;
        this.handleWidth = 0;
        this.labelWidth = 0;
        this.labelText = '';
        this.inverse = false;
        this.baseClass = 'bootstrap-switch';
        this.onText = 'ON';
        this.offText = 'OFF';
        this.disabled = false;
        this.readonly = false;
        this._focused = false;
        this._size = 'normal';
        this._animate = true;
        this._innerAnimate = true;
        this._indeterminate = false;
        this._onColor = 'primary';
        this._offColor = 'default';
        this._wrapperClass = 'wrapper';
        this._innerState = false;
        this._innerHandleWidth = 'auto';
        this._innerLabelWidth = 'auto';
        this._dragStart = null;
        this._dragEnd = null;
        this._onTouchedCallback = callback;
        this._onChangeCallback = callback;
        this.changeState = new EventEmitter();
    }
    /**
     * @return {?}
     */
    JwBootstrapSwitchNg2Component.prototype.$on = /**
     * @return {?}
     */
    function () {
        return this.on.nativeElement;
    };
    /**
     * @return {?}
     */
    JwBootstrapSwitchNg2Component.prototype.$off = /**
     * @return {?}
     */
    function () {
        return this.off.nativeElement;
    };
    /**
     * @return {?}
     */
    JwBootstrapSwitchNg2Component.prototype.$label = /**
     * @return {?}
     */
    function () {
        return this.label.nativeElement;
    };
    /**
     * @return {?}
     */
    JwBootstrapSwitchNg2Component.prototype.$container = /**
     * @return {?}
     */
    function () {
        return this.container.nativeElement;
    };
    /**
     * \@description: Function to set the Classes for the Wrapper Div
     * @return {?} string
     */
    JwBootstrapSwitchNg2Component.prototype.getWrapperClasses = /**
     * \@description: Function to set the Classes for the Wrapper Div
     * @return {?} string
     */
    function () {
        /** @type {?} */
        var output = this.baseClass + ' ' + this.baseClass + '-' + this._wrapperClass;
        if (this._focused) {
            output += ' ' + this.baseClass + '-focused';
        }
        if (this.readonly) {
            output += ' ' + this.baseClass + '-readonly';
        }
        if (this._size != null) {
            output += ' ' + this.baseClass + '-' + this._size;
        }
        if (this._innerState) {
            output += ' ' + this.baseClass + '-on';
        }
        else {
            output += ' ' + this.baseClass + '-off';
        }
        if (this._animate) {
            output += ' ' + this.baseClass + '-animate';
        }
        if (this.disabled) {
            output += ' ' + this.baseClass + '-disabled';
        }
        if (this._indeterminate || this._innerState === null || typeof this._innerState === 'undefined') {
            output += ' ' + this.baseClass + '-indeterminate';
        }
        if (this.inverse) {
            output += ' ' + this.baseClass + '-inverse';
        }
        return output;
    };
    /**
     * \@description Function to set the css classes for #on
     * @return {?} string
     */
    JwBootstrapSwitchNg2Component.prototype.getOnClasses = /**
     * \@description Function to set the css classes for #on
     * @return {?} string
     */
    function () {
        /** @type {?} */
        var output = this.baseClass + '-handle-on';
        if (this._onColor) {
            output += ' ' + this.baseClass + '-' + this._onColor;
        }
        return output;
    };
    /**
     * \@description Function to set the css classes for #off
     * @return {?} string
     */
    JwBootstrapSwitchNg2Component.prototype.getOffClasses = /**
     * \@description Function to set the css classes for #off
     * @return {?} string
     */
    function () {
        /** @type {?} */
        var output = this.baseClass + '-handle-off';
        if (this._offColor) {
            output += ' ' + this.baseClass + '-' + this._offColor;
        }
        return output;
    };
    /**
     * \@description Function set the marging of the #label when change the state
     * @return {?} string
     */
    JwBootstrapSwitchNg2Component.prototype.getLabelMarginLeft = /**
     * \@description Function set the marging of the #label when change the state
     * @return {?} string
     */
    function () {
        /** @type {?} */
        var width = (this.inverse) ? -this.handleWidth : 0;
        if (this._indeterminate || this._innerState === null || typeof this._innerState === 'undefined') {
            width = -(this.handleWidth / 2);
        }
        else if (this._dragEnd) {
            width = this._dragEnd;
        }
        else if (!this._innerState) {
            if (!this.inverse) {
                width = -this.handleWidth;
            }
            else {
                width = 0;
            }
        }
        return width + 'px';
    };
    /**
     * @param {?} changes
     * @return {?}
     */
    JwBootstrapSwitchNg2Component.prototype.ngOnChanges = /**
     * @param {?} changes
     * @return {?}
     */
    function (changes) {
        if (changes['setLabelText'] ||
            changes['setOnText'] ||
            changes['setHandleWidth'] ||
            changes['setLabelWidth'] ||
            changes['setOffText'] ||
            changes['setSize']) {
            this.calculateWith(true);
        }
    };
    /**
     * @return {?}
     */
    JwBootstrapSwitchNg2Component.prototype.ngAfterViewInit = /**
     * @return {?}
     */
    function () {
        this.calculateWith();
    };
    /**
     * @return {?}
     */
    JwBootstrapSwitchNg2Component.prototype.onClick = /**
     * @return {?}
     */
    function () {
        if (!this.disabled && !this.readonly && !this._dragEnd) {
            this.setStateValue(!this._innerState);
        }
        else if (this._dragEnd) {
            this._dragEnd = null;
        }
    };
    /**
     * @param {?} e
     * @return {?}
     */
    JwBootstrapSwitchNg2Component.prototype.onKeyDown = /**
     * @param {?} e
     * @return {?}
     */
    function (e) {
        if (!e.which || this.disabled || this.readonly) {
            return;
        }
        switch (e.which) {
            case 37:
                e.preventDefault();
                e.stopImmediatePropagation();
                this.setStateValue(false);
                break;
            case 39:
                e.preventDefault();
                e.stopImmediatePropagation();
                this.setStateValue(true);
                break;
        }
    };
    /**
     * @param {?} e
     * @return {?}
     */
    JwBootstrapSwitchNg2Component.prototype.onDragStart = /**
     * @param {?} e
     * @return {?}
     */
    function (e) {
        if (e.target === this.$label()) {
            if (this._dragStart || this.disabled || this.readonly) {
                return;
            }
            e.preventDefault();
            e.stopPropagation();
            this._dragStart = (e.pageX || e.touches[0].pageX) - parseInt(this.$container().style.marginLeft, 10);
            if (this._animate) {
                this._animate = !this._animate;
            }
        }
    };
    /**
     * @param {?} e
     * @return {?}
     */
    JwBootstrapSwitchNg2Component.prototype.onDragMove = /**
     * @param {?} e
     * @return {?}
     */
    function (e) {
        if (this._dragStart) {
            e.preventDefault();
            /** @type {?} */
            var difference = (e.pageX || e.touches[0].pageX) - this._dragStart;
            if (difference < -Number(this.handleWidth) || difference > 0) {
                return;
            }
            this._dragEnd = difference;
        }
    };
    /**
     * @param {?} e
     * @param {?=} removeDragEnd
     * @return {?}
     */
    JwBootstrapSwitchNg2Component.prototype.onDragEnd = /**
     * @param {?} e
     * @param {?=} removeDragEnd
     * @return {?}
     */
    function (e, removeDragEnd) {
        if (removeDragEnd === void 0) { removeDragEnd = false; }
        if (this._dragStart) {
            e.preventDefault();
            e.stopPropagation();
            if (this._dragEnd) {
                /** @type {?} */
                var state = this._dragEnd > -(Number(this.handleWidth) / 2);
                this.setStateValue((this.inverse) ? !state : state);
            }
            this._dragStart = null;
            if (removeDragEnd) {
                this._dragEnd = null;
            }
            if (this._innerAnimate) {
                this._animate = true;
            }
        }
    };
    /**
     * @param {?} e
     * @return {?}
     */
    JwBootstrapSwitchNg2Component.prototype.onTouchStart = /**
     * @param {?} e
     * @return {?}
     */
    function (e) {
        this.onDragStart(e);
    };
    /**
     * @param {?} e
     * @return {?}
     */
    JwBootstrapSwitchNg2Component.prototype.onMouseDown = /**
     * @param {?} e
     * @return {?}
     */
    function (e) {
        this.onDragStart(e);
    };
    /**
     * @param {?} e
     * @return {?}
     */
    JwBootstrapSwitchNg2Component.prototype.onTouchMove = /**
     * @param {?} e
     * @return {?}
     */
    function (e) {
        this.onDragMove(e);
    };
    /**
     * @param {?} e
     * @return {?}
     */
    JwBootstrapSwitchNg2Component.prototype.onMouseMove = /**
     * @param {?} e
     * @return {?}
     */
    function (e) {
        this.onDragMove(e);
    };
    /**
     * @param {?} e
     * @return {?}
     */
    JwBootstrapSwitchNg2Component.prototype.onMouseUp = /**
     * @param {?} e
     * @return {?}
     */
    function (e) {
        this.onDragEnd(e);
    };
    /**
     * @param {?} e
     * @return {?}
     */
    JwBootstrapSwitchNg2Component.prototype.onTouchEnd = /**
     * @param {?} e
     * @return {?}
     */
    function (e) {
        this.onDragEnd(e, true);
    };
    /**
     * @param {?} e
     * @return {?}
     */
    JwBootstrapSwitchNg2Component.prototype.onMouseLeave = /**
     * @param {?} e
     * @return {?}
     */
    function (e) {
        this.onDragEnd(e, true);
    };
    /**
     * @return {?}
     */
    JwBootstrapSwitchNg2Component.prototype.onFocus = /**
     * @return {?}
     */
    function () {
        this._focused = true;
    };
    /**
     * @return {?}
     */
    JwBootstrapSwitchNg2Component.prototype.onBlur = /**
     * @return {?}
     */
    function () {
        this._focused = false;
        this._onTouchedCallback();
    };
    /**
     * \@description Function to make recalculate the size of the elements when options change
     * @param {?=} disableAnimation
     * @return {?}
     */
    JwBootstrapSwitchNg2Component.prototype.calculateWith = /**
     * \@description Function to make recalculate the size of the elements when options change
     * @param {?=} disableAnimation
     * @return {?}
     */
    function (disableAnimation) {
        var _this = this;
        if (disableAnimation === void 0) { disableAnimation = false; }
        /** @type {?} */
        var self = this;
        if (disableAnimation && this._innerAnimate) {
            this._animate = false;
        }
        setTimeout(function () {
            self.$on().style.width = 'auto';
            self.$off().style.width = 'auto';
            self.$label().style.width = 'auto';
            /** @type {?} */
            var width = (self._innerHandleWidth === 'auto')
                ? Math.max(self.$on().offsetWidth, self.$off().offsetWidth)
                : self._innerHandleWidth;
            if (self.$label().offsetWidth < width) {
                if (self._innerLabelWidth === 'auto') {
                    self.labelWidth = Number(width);
                }
                else {
                    self.labelWidth = Number(self._innerLabelWidth);
                }
            }
            else {
                if (self._innerLabelWidth === 'auto') {
                    self.labelWidth = self.$label().offsetWidth;
                }
                else {
                    self.labelWidth = Number(self._innerLabelWidth);
                }
            }
            self.handleWidth = Number(width);
            self.ngZone.run(function () {
                self.$label().style.width = self.labelWidth + 'px';
                self.$on().style.width = self.handleWidth + 'px';
                self.$off().style.width = self.handleWidth + 'px';
                setTimeout(function () {
                    if (disableAnimation && _this._innerAnimate) {
                        _this._animate = true;
                    }
                });
            });
        });
    };
    Object.defineProperty(JwBootstrapSwitchNg2Component.prototype, "setBaseClass", {
        // Functions to set inputs and the private variables of the Switch
        set: /**
         * @param {?} value
         * @return {?}
         */
        function (value) {
            this.baseClass = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(JwBootstrapSwitchNg2Component.prototype, "setWrapperClass", {
        set: /**
         * @param {?} value
         * @return {?}
         */
        function (value) {
            this._wrapperClass = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(JwBootstrapSwitchNg2Component.prototype, "setOffText", {
        set: /**
         * @param {?} value
         * @return {?}
         */
        function (value) {
            this.offText = (value) ? value : 'OFF';
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(JwBootstrapSwitchNg2Component.prototype, "setLabelText", {
        set: /**
         * @param {?} value
         * @return {?}
         */
        function (value) {
            this.labelText = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(JwBootstrapSwitchNg2Component.prototype, "setOnText", {
        set: /**
         * @param {?} value
         * @return {?}
         */
        function (value) {
            this.onText = (value) ? value : 'ON';
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(JwBootstrapSwitchNg2Component.prototype, "setSize", {
        set: /**
         * @param {?} value
         * @return {?}
         */
        function (value) {
            if (value) {
                this._size = value;
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(JwBootstrapSwitchNg2Component.prototype, "setAnimate", {
        set: /**
         * @param {?} value
         * @return {?}
         */
        function (value) {
            this._animate = value;
            this._innerAnimate = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(JwBootstrapSwitchNg2Component.prototype, "setOnColor", {
        set: /**
         * @param {?} value
         * @return {?}
         */
        function (value) {
            if (value) {
                this._onColor = value;
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(JwBootstrapSwitchNg2Component.prototype, "setOffColor", {
        set: /**
         * @param {?} value
         * @return {?}
         */
        function (value) {
            if (value) {
                this._offColor = value;
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(JwBootstrapSwitchNg2Component.prototype, "setDisabled", {
        set: /**
         * @param {?} value
         * @return {?}
         */
        function (value) {
            this.disabled = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(JwBootstrapSwitchNg2Component.prototype, "setReadOnly", {
        set: /**
         * @param {?} value
         * @return {?}
         */
        function (value) {
            this.readonly = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(JwBootstrapSwitchNg2Component.prototype, "setIndeterminate", {
        set: /**
         * @param {?} value
         * @return {?}
         */
        function (value) {
            this._indeterminate = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(JwBootstrapSwitchNg2Component.prototype, "setInverse", {
        set: /**
         * @param {?} value
         * @return {?}
         */
        function (value) {
            this.inverse = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(JwBootstrapSwitchNg2Component.prototype, "setHandleWidth", {
        set: /**
         * @param {?} value
         * @return {?}
         */
        function (value) {
            this._innerHandleWidth = (typeof (value) !== 'undefined') ? value : 'auto';
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(JwBootstrapSwitchNg2Component.prototype, "setLabelWidth", {
        set: /**
         * @param {?} value
         * @return {?}
         */
        function (value) {
            this._innerLabelWidth = (typeof (value) !== 'undefined') ? value : 'auto';
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(JwBootstrapSwitchNg2Component.prototype, "value", {
        get: /**
         * @return {?}
         */
        function () {
            return this._innerState;
        },
        set: /**
         * @param {?} v
         * @return {?}
         */
        function (v) {
            if (v === null || typeof v === 'undefined') {
                this._indeterminate = true;
            }
            this.setStateValue(v);
        },
        enumerable: true,
        configurable: true
    });
    /**
     * @param {?} v
     * @return {?}
     */
    JwBootstrapSwitchNg2Component.prototype.setStateValue = /**
     * @param {?} v
     * @return {?}
     */
    function (v) {
        if (v !== this._innerState) {
            this._onChangeCallback(v);
            this.changeState.emit({
                previousValue: this._innerState,
                currentValue: v
            });
            this._innerState = v;
        }
    };
    /**
     * @param {?} value
     * @return {?}
     */
    JwBootstrapSwitchNg2Component.prototype.writeValue = /**
     * @param {?} value
     * @return {?}
     */
    function (value) {
        if (value !== this._innerState) {
            this._innerState = value;
        }
    };
    /**
     * @param {?} fn
     * @return {?}
     */
    JwBootstrapSwitchNg2Component.prototype.registerOnChange = /**
     * @param {?} fn
     * @return {?}
     */
    function (fn) {
        this._onChangeCallback = fn;
    };
    /**
     * @param {?} fn
     * @return {?}
     */
    JwBootstrapSwitchNg2Component.prototype.registerOnTouched = /**
     * @param {?} fn
     * @return {?}
     */
    function (fn) {
        this._onTouchedCallback = fn;
    };
    /** @nocollapse */
    JwBootstrapSwitchNg2Component.ctorParameters = function () { return [
        { type: NgZone }
    ]; };
    JwBootstrapSwitchNg2Component.propDecorators = {
        changeState: [{ type: Output }],
        container: [{ type: ViewChild, args: ['container',] }],
        on: [{ type: ViewChild, args: ['on',] }],
        label: [{ type: ViewChild, args: ['label',] }],
        off: [{ type: ViewChild, args: ['off',] }],
        onClick: [{ type: HostListener, args: ['click',] }],
        onKeyDown: [{ type: HostListener, args: ['keydown', ['$event'],] }],
        onTouchStart: [{ type: HostListener, args: ['touchstart', ['$event'],] }],
        onMouseDown: [{ type: HostListener, args: ['mousedown', ['$event'],] }],
        onTouchMove: [{ type: HostListener, args: ['touchmove', ['$event'],] }],
        onMouseMove: [{ type: HostListener, args: ['mousemove', ['$event'],] }],
        onMouseUp: [{ type: HostListener, args: ['mouseup', ['$event'],] }],
        onTouchEnd: [{ type: HostListener, args: ['touchend', ['$event'],] }],
        onMouseLeave: [{ type: HostListener, args: ['mouseleave', ['$event'],] }],
        setBaseClass: [{ type: Input, args: ['switch-base-class',] }],
        setWrapperClass: [{ type: Input, args: ['switch-wrapper-class',] }],
        setOffText: [{ type: Input, args: ['switch-off-text',] }],
        setLabelText: [{ type: Input, args: ['switch-label-text',] }],
        setOnText: [{ type: Input, args: ['switch-on-text',] }],
        setSize: [{ type: Input, args: ['switch-size',] }],
        setAnimate: [{ type: Input, args: ['switch-animate',] }],
        setOnColor: [{ type: Input, args: ['switch-on-color',] }],
        setOffColor: [{ type: Input, args: ['switch-off-color',] }],
        setDisabled: [{ type: Input, args: ['switch-disabled',] }],
        setReadOnly: [{ type: Input, args: ['switch-readonly',] }],
        setIndeterminate: [{ type: Input, args: ['switch-indeterminate',] }],
        setInverse: [{ type: Input, args: ['switch-inverse',] }],
        setHandleWidth: [{ type: Input, args: ['switch-handle-width',] }],
        setLabelWidth: [{ type: Input, args: ['switch-label-width',] }]
    };
JwBootstrapSwitchNg2Component.ɵfac = function JwBootstrapSwitchNg2Component_Factory(t) { return new (t || JwBootstrapSwitchNg2Component)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.NgZone)); };
JwBootstrapSwitchNg2Component.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: JwBootstrapSwitchNg2Component, selectors: [["bSwitch"]], viewQuery: function JwBootstrapSwitchNg2Component_Query(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵviewQuery(_c0, true);
        ɵngcc0.ɵɵviewQuery(_c1, true);
        ɵngcc0.ɵɵviewQuery(_c2, true);
        ɵngcc0.ɵɵviewQuery(_c3, true);
    } if (rf & 2) {
        var _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.container = _t.first);
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.on = _t.first);
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.label = _t.first);
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.off = _t.first);
    } }, hostBindings: function JwBootstrapSwitchNg2Component_HostBindings(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵlistener("click", function JwBootstrapSwitchNg2Component_click_HostBindingHandler() { return ctx.onClick(); })("keydown", function JwBootstrapSwitchNg2Component_keydown_HostBindingHandler($event) { return ctx.onKeyDown($event); })("touchstart", function JwBootstrapSwitchNg2Component_touchstart_HostBindingHandler($event) { return ctx.onTouchStart($event); })("mousedown", function JwBootstrapSwitchNg2Component_mousedown_HostBindingHandler($event) { return ctx.onMouseDown($event); })("touchmove", function JwBootstrapSwitchNg2Component_touchmove_HostBindingHandler($event) { return ctx.onTouchMove($event); })("mousemove", function JwBootstrapSwitchNg2Component_mousemove_HostBindingHandler($event) { return ctx.onMouseMove($event); })("mouseup", function JwBootstrapSwitchNg2Component_mouseup_HostBindingHandler($event) { return ctx.onMouseUp($event); })("touchend", function JwBootstrapSwitchNg2Component_touchend_HostBindingHandler($event) { return ctx.onTouchEnd($event); })("mouseleave", function JwBootstrapSwitchNg2Component_mouseleave_HostBindingHandler($event) { return ctx.onMouseLeave($event); });
    } }, inputs: { setBaseClass: ["switch-base-class", "setBaseClass"], setWrapperClass: ["switch-wrapper-class", "setWrapperClass"], setOffText: ["switch-off-text", "setOffText"], setLabelText: ["switch-label-text", "setLabelText"], setOnText: ["switch-on-text", "setOnText"], setSize: ["switch-size", "setSize"], setAnimate: ["switch-animate", "setAnimate"], setOnColor: ["switch-on-color", "setOnColor"], setOffColor: ["switch-off-color", "setOffColor"], setDisabled: ["switch-disabled", "setDisabled"], setReadOnly: ["switch-readonly", "setReadOnly"], setIndeterminate: ["switch-indeterminate", "setIndeterminate"], setInverse: ["switch-inverse", "setInverse"], setHandleWidth: ["switch-handle-width", "setHandleWidth"], setLabelWidth: ["switch-label-width", "setLabelWidth"] }, outputs: { changeState: "changeState" }, features: [ɵngcc0.ɵɵProvidersFeature([CUSTOM_INPUT]), ɵngcc0.ɵɵNgOnChangesFeature], decls: 11, vars: 27, consts: [["container", ""], [3, "innerHTML"], ["on", ""], ["label", ""], ["off", ""], ["type", "checkbox", 3, "ngModel", "readonly", "disabled", "ngModelChange", "focus", "blur"]], template: function JwBootstrapSwitchNg2Component_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div");
        ɵngcc0.ɵɵelementStart(1, "div", null, 0);
        ɵngcc0.ɵɵelement(3, "span", 1, 2);
        ɵngcc0.ɵɵelementStart(5, "span", null, 3);
        ɵngcc0.ɵɵtext(7);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelement(8, "span", 1, 4);
        ɵngcc0.ɵɵelementStart(10, "input", 5);
        ɵngcc0.ɵɵlistener("ngModelChange", function JwBootstrapSwitchNg2Component_Template_input_ngModelChange_10_listener($event) { return ctx.value = $event; })("focus", function JwBootstrapSwitchNg2Component_Template_input_focus_10_listener() { return ctx.onFocus(); })("blur", function JwBootstrapSwitchNg2Component_Template_input_blur_10_listener() { return ctx.onBlur(); });
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵclassMap(ctx.getWrapperClasses());
        ɵngcc0.ɵɵstyleProp("width", ctx.handleWidth + ctx.labelWidth + "px");
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵclassMapInterpolate1("", ctx.baseClass, "-container");
        ɵngcc0.ɵɵstyleProp("width", ctx.handleWidth * 2 + ctx.labelWidth + "px")("margin-left", ctx.getLabelMarginLeft());
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵclassMap(ctx.inverse ? ctx.getOffClasses() : ctx.getOnClasses());
        ɵngcc0.ɵɵproperty("innerHTML", ctx.inverse ? ctx.offText : ctx.onText, ɵngcc0.ɵɵsanitizeHtml);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵclassMapInterpolate1("", ctx.baseClass, "-label");
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵtextInterpolate1("\u00A0", ctx.labelText, "");
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵclassMap(ctx.inverse ? ctx.getOnClasses() : ctx.getOffClasses());
        ɵngcc0.ɵɵproperty("innerHTML", ctx.inverse ? ctx.onText : ctx.offText, ɵngcc0.ɵɵsanitizeHtml);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("ngModel", ctx.value)("readonly", ctx.readonly)("disabled", ctx.disabled);
    } }, directives: [ɵngcc1.CheckboxControlValueAccessor, ɵngcc1.NgControlStatus, ɵngcc1.NgModel], encapsulation: 2 });
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(JwBootstrapSwitchNg2Component, [{
        type: Component,
        args: [{
                selector: 'bSwitch',
                providers: [CUSTOM_INPUT],
                template: "\n      <div class=\"{{ getWrapperClasses() }}\" [style.width]=\" (handleWidth  + labelWidth ) +'px'\">\n          <div #container class=\"{{ baseClass }}-container\"\n               [style.width]=\" ((handleWidth * 2) + labelWidth) +'px'\"\n               [style.margin-left]=\"getLabelMarginLeft()\"><!--\n              --><span #on [innerHTML]=\"(inverse) ? offText : onText\"\n                class=\"{{ (inverse) ? getOffClasses() : getOnClasses() }}\"></span><!--\n              --><span #label class=\"{{ baseClass }}-label\">&nbsp;{{ labelText }}</span><!--\n              --><span #off [innerHTML]=\"(inverse) ? onText : offText\"\n                class=\"{{ (inverse) ? getOnClasses() : getOffClasses() }}\"></span><!--\n              --><input type=\"checkbox\" [(ngModel)]=\"value\" [readonly]=\"readonly\" [disabled]=\"disabled\"\n                     (focus)=\"onFocus()\" (blur)=\"onBlur()\">\n          </div>\n      </div>"
            }]
    }], function () { return [{ type: ɵngcc0.NgZone }]; }, { changeState: [{
            type: Output
        }], onClick: [{
            type: HostListener,
            args: ['click']
        }], onKeyDown: [{
            type: HostListener,
            args: ['keydown', ['$event']]
        }], onTouchStart: [{
            type: HostListener,
            args: ['touchstart', ['$event']]
        }], onMouseDown: [{
            type: HostListener,
            args: ['mousedown', ['$event']]
        }], onTouchMove: [{
            type: HostListener,
            args: ['touchmove', ['$event']]
        }], onMouseMove: [{
            type: HostListener,
            args: ['mousemove', ['$event']]
        }], onMouseUp: [{
            type: HostListener,
            args: ['mouseup', ['$event']]
        }], onTouchEnd: [{
            type: HostListener,
            args: ['touchend', ['$event']]
        }], onMouseLeave: [{
            type: HostListener,
            args: ['mouseleave', ['$event']]
        }], setBaseClass: [{
            type: Input,
            args: ['switch-base-class']
        }], setWrapperClass: [{
            type: Input,
            args: ['switch-wrapper-class']
        }], setOffText: [{
            type: Input,
            args: ['switch-off-text']
        }], setLabelText: [{
            type: Input,
            args: ['switch-label-text']
        }], setOnText: [{
            type: Input,
            args: ['switch-on-text']
        }], setSize: [{
            type: Input,
            args: ['switch-size']
        }], setAnimate: [{
            type: Input,
            args: ['switch-animate']
        }], setOnColor: [{
            type: Input,
            args: ['switch-on-color']
        }], setOffColor: [{
            type: Input,
            args: ['switch-off-color']
        }], setDisabled: [{
            type: Input,
            args: ['switch-disabled']
        }], setReadOnly: [{
            type: Input,
            args: ['switch-readonly']
        }], setIndeterminate: [{
            type: Input,
            args: ['switch-indeterminate']
        }], setInverse: [{
            type: Input,
            args: ['switch-inverse']
        }], setHandleWidth: [{
            type: Input,
            args: ['switch-handle-width']
        }], setLabelWidth: [{
            type: Input,
            args: ['switch-label-width']
        }], container: [{
            type: ViewChild,
            args: ['container']
        }], on: [{
            type: ViewChild,
            args: ['on']
        }], label: [{
            type: ViewChild,
            args: ['label']
        }], off: [{
            type: ViewChild,
            args: ['off']
        }] }); })();
    return JwBootstrapSwitchNg2Component;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
var JwBootstrapSwitchNg2Module = /** @class */ (function () {
    function JwBootstrapSwitchNg2Module() {
    }
JwBootstrapSwitchNg2Module.ɵmod = ɵngcc0.ɵɵdefineNgModule({ type: JwBootstrapSwitchNg2Module });
JwBootstrapSwitchNg2Module.ɵinj = ɵngcc0.ɵɵdefineInjector({ factory: function JwBootstrapSwitchNg2Module_Factory(t) { return new (t || JwBootstrapSwitchNg2Module)(); }, imports: [[
            FormsModule
        ]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(JwBootstrapSwitchNg2Module, { declarations: function () { return [JwBootstrapSwitchNg2Component]; }, imports: function () { return [FormsModule]; }, exports: function () { return [JwBootstrapSwitchNg2Component]; } }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(JwBootstrapSwitchNg2Module, [{
        type: NgModule,
        args: [{
                imports: [
                    FormsModule
                ],
                declarations: [JwBootstrapSwitchNg2Component],
                exports: [JwBootstrapSwitchNg2Component]
            }]
    }], function () { return []; }, null); })();
    return JwBootstrapSwitchNg2Module;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */

export { JwBootstrapSwitchNg2Component, JwBootstrapSwitchNg2Module };

//# sourceMappingURL=data:application/json;charset=utf-8;base64,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